import { styled, Button, ButtonProps, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { CerebroIcon } from './CerebroIcon';

export const CerebroSelectableIcon: React.FC<CerebroSelectableIconProps> = ({
	sx,
	wide = false,
	stretch = false,

	icon: Icon,

	name,
	error = false,
	value,
	onChange,

	children,
}) => {
	return (
		<StyledWrapper
			error={error}
			wide={wide}
			selected={value}
			stretch={stretch}
			onClick={() => onChange?.({ target: { name, value: !value } })}
			sx={sx}
		>
			<CerebroIcon sx={{ marginBottom: 2 }}>
				<Icon />
			</CerebroIcon>
			{children}
		</StyledWrapper>
	);
};

// Like a partial React.ChangeEvent because formik falls back to handling any value it receives on change as an event if it isn't a string.
export interface CerebroSelectableIconChangeEvent {
	target: {
		name: string;
		value: boolean;
	};
}

export interface CerebroSelectableIconProps {
	sx?: SxProps<Theme>;

	wide?: boolean;
	stretch?: boolean;

	icon: React.ComponentType;

	error?: boolean;
	name: string;
	value: boolean;
	onChange?: (event: CerebroSelectableIconChangeEvent) => void;

}

const Wrapper: React.FC<ButtonProps & { error: boolean; stretch: boolean; wide: boolean; selected: boolean }> =
	props => <Button {...props} />;

const StyledWrapper = styled(Wrapper, {
	shouldForwardProp: prop => prop !== 'error' && prop !== 'stretch' && prop !== 'selected' && prop !== 'wide',
})(({ error, stretch, selected, wide, theme }) => ({
	alignItems: 'center',

	backgroundColor: selected ? theme.palette.primary.main : theme.palette.gray.background,

	boxShadow: theme.shadows[3],

	borderStyle: 'solid',
	borderWidth: 1,
	borderColor: error ? theme.palette.error.main : selected ? theme.palette.primary.main : theme.palette.gray.dark,

	cursor: 'pointer',
	color: selected ? theme.palette.primary.contrastText : theme.palette.gray.dark,

	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',

	paddingTop: theme.spacing(2),
	paddingBottom: theme.spacing(2),
	paddingLeft: wide ? theme.spacing(3) : theme.spacing(2),
	paddingRight: wide ? theme.spacing(3) : theme.spacing(2),

	textTransform: 'none',

	width: stretch ? '100%' : 'auto',
	height: stretch ? '100%' : 'auto',

	'&:hover': {
		boxShadow: error
			? theme.solidShadow(theme.palette.error.main)
			: selected
			? theme.shadows[3]
			: theme.solidShadow(theme.palette.primary.main),

		borderColor: error ? theme.palette.error.main : selected ? theme.palette.gray.dark : theme.palette.primary.main,
		backgroundColor: selected ? theme.palette.primary.light : theme.palette.gray.background,
	},
}));
